import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedRole } = useAuth();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Role-based navigation menu
  const getNavItems = () => {
    switch (selectedRole) {
      case 'super_admin':
        return [
          { path: '/users-dashboard', icon: '👥', label: 'Users Dashboard' }
        ];
      
      case 'institute_admin':
        return [
          { path: '/admin-dashboard', icon: '⚙️', label: 'Institute Admin Dashboard' }
        ];
      
      case 'instructor':
      default:
        return [
          { path: '/courses', icon: '🏫', label: 'My Courses' },
          { path: '/dashboard', icon: '📊', label: 'Dashboard' },
          { path: '/import-lms', icon: '📥', label: 'Import from LMS' },
          // TODO: Uncomment following items when their features are implemented
          // { path: '/chat', icon: '💬', label: 'Chat' },
          // { path: '/upload', icon: '📤', label: 'Upload' },
          // { path: '/agent-chat', icon: '🤖', label: 'AI Agent' },
          // { path: '/lesson-resources', icon: '📚', label: 'Lesson Resources' }
        ];
    }
  };

  const navItems = getNavItems();

  return (
    <nav className="sidebar">
      {navItems.map(item => (
        <div 
          key={item.path}
          className={`nav-item ${isActive(item.path) ? 'active' : ''}`} 
          onClick={() => navigate(item.path)}
        >
          <span>{item.icon}</span>
          <span>{item.label}</span>
        </div>
      ))}
    </nav>
  );
}

export default Sidebar;

